<template>
  <div>
    <div v-if="error && !showPasswordReset" class="alert alert-warning alert-dismissible">
      <span class="text-sm">Email or Password Invalid</span>
      <button type="button" class="close" aria-label="Close" @click="() => (error = false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <BushelTextInputMaterial
      v-if="!show2fa"
      type="email"
      name="email"
      autofocus
      :label-active="'Email'"
      :error="submitted && !validateEmail(formData.email)"
      autocomplete="email"
      :value="formData.email"
      :error-text="'Required'"
      @input="(email) => (formData.email = email)"
    />
    <BushelTextInputMaterial
      v-if="!show2fa && !showPasswordReset"
      :type="showPassword ? 'text' : 'password'"
      name="password"
      :error="submitted && formData.password.length < 8"
      :error-text="'8 char min, letters, mixedCase, numbers, symbols'"
      :label-active="'Password'"
      :value="formData.password"
      :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
      :message="'8 char min, letters, mixedCase, numbers, symbols'"
      @icon-clicked="showPassword = !showPassword"
      @input="(password) => (formData.password = password)"
    />
    <BushelTextInputMaterial
      v-if="show2fa"
      ref="twofa"
      autofocus
      type="number"
      :label-active="'2 Factor Token'"
      :error="submitted && !formData.token"
      :value="formData.token"
      :error-text="'Required'"
      :message="'Please use the Authy App on your phone to login'"
      @input="on2faInput"
    />
    <BushelBtn
      v-if="!show2fa"
      class="btn-block mt-4"
      variant="success"
      :disabled="(resetSubmitted && showPasswordReset) || submitting"
      :loading="submitting"
      @click="submit"
    >
      {{ showPasswordReset ? (resetSubmitted ? "Check Your Email" : "Reset Password") : "Login" }}
    </BushelBtn>
    <BushelBtn v-if="show2fa" class="btn-block mt-4" variant="success" :loading="submitting" @click="submit"> Verify </BushelBtn>
    <div v-if="!show2fa" class="mt-2">
      <BushelBtn class="btn-sm" variant="secondary" flat @click="togglePasswordReset">
        {{ showPasswordReset ? "Back to Login" : "Forgot Password?" }}
      </BushelBtn>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import * as api from "@/services/api";
import BushelTextInputMaterial from "@/components/common/forms/BushelTextInputMaterial.vue";
import { validateEmail } from "@/services/helpers";

export default {
  components: {
    BushelTextInputMaterial,
  },
  props: {},
  emits: ["loggedIn"],
  data() {
    return {
      submitted: false,
      submitting: false,
      showPassword: false,
      show2fa: false,
      showPasswordReset: false,
      resetSubmitted: false,
      error: false,
      formData: {
        email: "",
        password: "",
        token: "",
      },
    };
  },
  methods: {
    ...mapActions({
      login: "auth/loginProfileWidget",
    }),
    validateEmail,
    on2faInput($event) {
      this.formData.token = $event;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
      this.submitted = false;
      this.error = false;
      this.resetSubmitted = false;
    },
    submit() {
      if (this.showPasswordReset) {
        this.resetPassword();
      } else {
        this.signIn();
      }
    },
    resetPassword() {
      this.submitted = true;
      if (this.validateEmail(this.formData.email)) {
        this.submitting = true;
        this.resetSubmitted = true;
        api.post("/auth/password/resetEmail", { email: this.formData.email }).then(() => {
          this.submitting = false;
        });
      }
    },
    signIn() {
      this.submitted = true;
      this.submitting = true;
      this.error = false;

      if (this.isValid()) {
        const payload = { email: this.formData.email, token: this.formData.token, password: this.formData.password };
        this.login(payload).then(
          (response) => {
            this.submitting = false;
            if (response === "success") {
              this.$emit("loggedIn", response);
            } else if (response === "two factor enabled") {
              this.submitted = false;
              this.show2fa = true;
            } else {
              this.error = true;
            }
          },
          () => {
            this.error = true;
            this.submitting = false;
          },
        );
      } else {
        this.error = true;
        this.submitting = false;
      }
    },
    isValid() {
      return this.validateEmail(this.formData.email) && this.formData.password.length >= 8;
    },
  },
};
</script>
